import { type IntegrationsOverviewDto } from '@aysar/contracts';
import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '@/shared/store/middleware/base-query-with-auth/base-query-with-auth';

/**
 * The cross-module read bridge for the integrations overview (W6): a screen
 * outside `modules/Integrations` asking "does this capability have a working
 * provider" reads here, never the module's own api.
 */
export const integrationsLookupApi = createApi({
  reducerPath: 'integrationsLookupApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['IntegrationsOverviewLookup'],
  endpoints: (builder) => ({
    lookupIntegrationsOverview: builder.query<IntegrationsOverviewDto, void>({
      query: () => ({ url: '/admin/integrations', method: 'GET' }),
      providesTags: ['IntegrationsOverviewLookup'],
    }),
  }),
});

export const { useLookupIntegrationsOverviewQuery } = integrationsLookupApi;
